import type { SuspenseFallbackProps } from '../../types/error-boundary';
import { cn } from '../../utils/utils';

import { LoadingSpinner } from './loading-spinner';

const variantClasses = {
  inline: '',
  centered: 'flex items-center justify-center min-h-[200px]',
  fullPage: 'fixed inset-0 flex items-center justify-center bg-background z-50',
  overlay:
    'absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-40',
};

export const SuspenseFallback = ({
  variant = 'centered',
  size = 'md',
  message,
  className,
  children,
}: SuspenseFallbackProps) => {
  if (children) return <>{children}</>;

  return (
    <div
      className={cn(variantClasses[variant], 'animate-[fadeIn_0.1s_ease-out_0.1s_both]', className)}
      role="status"
      aria-label="Loading"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-3">
        <LoadingSpinner size={size} />
        {message && <p className="text-sm text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
};

export default SuspenseFallback;
